import { CONFIRMATION_FILTERS } from "../../utils/appointmentDisplay";
import "./ConfirmationFilterChips.css";

/**
 * Quick confirmed / not-confirmed view for the visible calendar range.
 * "הכל" first and selected by default; non-matching meetings are DIMMED by the
 * views (never hidden). Counts exclude blocked time and cancelled meetings.
 */
function ConfirmationFilterChips({ value = "all", onChange, counts = {} }) {
  return (
    <div className="ccf-chips" role="group" aria-label="סינון לפי אישור הגעה">
      {CONFIRMATION_FILTERS.map((f) => {
        const active = value === f.key;
        const count = counts[f.key] ?? 0;
        return (
          <button
            key={f.key}
            type="button"
            className={`ccf-chip ccf-chip-${f.key}${active ? " active" : ""}`}
            aria-pressed={active}
            onClick={() => onChange?.(active && f.key !== "all" ? "all" : f.key)}
          >
            <span className="ccf-label">{f.label}</span>
            <span className="ccf-count">{count}</span>
          </button>
        );
      })}
    </div>
  );
}

export default ConfirmationFilterChips;
